var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#10178A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.91968 12.0223L6.42986 6.74302L6.08363 6H7.52266L10.6928 12.8436H7.74987L8.87513 12.0321L8.19348 10.5754H5.02329L4.37411 11.9637L5.76986 12.8436H3L3.91968 12.0223ZM8.04201 10.2528L6.62462 7.15363L5.17477 10.2528H8.04201Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7495 11.9441C14.497 12.2635 14.2121 12.5112 13.8947 12.6872C13.5846 12.8631 13.26 12.9511 12.921 12.9511C12.5098 12.9511 12.1564 12.8305 11.8606 12.5894C11.5649 12.3482 11.417 12.0256 11.417 11.6215C11.417 11.2696 11.536 10.986 11.7741 10.7709C12.0121 10.5493 12.3619 10.3734 12.8236 10.243C13.2852 10.1061 13.9092 9.98231 14.6954 9.87151V9.38268C14.6954 8.99814 14.598 8.69832 14.4033 8.48324C14.2085 8.26816 13.9705 8.15084 13.6892 8.13128L12.3691 9.56844L11.4495 8.66899C11.7236 8.49953 11.976 8.36266 12.2068 8.25838C12.4449 8.14758 12.6937 8.06285 12.9534 8.00419C13.2203 7.93901 13.5052 7.90643 13.8082 7.90643C14.4357 7.90643 14.9442 8.04656 15.3338 8.32682C15.7305 8.60056 15.9288 8.98836 15.9288 9.49022V11.8268L17 12.3645L14.7495 13V11.9441ZM13.581 12.1788C13.9849 12.1788 14.3564 12.0061 14.6954 11.6606V10.1159C14.0101 10.2398 13.516 10.4092 13.2131 10.6243C12.9101 10.8329 12.7587 11.1034 12.7587 11.4358C12.7587 11.6899 12.838 11.879 12.9967 12.0028C13.1554 12.1201 13.3501 12.1788 13.581 12.1788Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/text.516b277086e36fd985712b2f7953fc7f.svg";
export { ForwardRef as ReactComponent };